import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import classes from './styles/index.module.scss';

const TooltipList = ({ items }) => {
	return (
		<div className={classes.tooltipList}>
			{map(items, (item, index) => {
				return (
					<div key={index}>
						{item.title && <h2>{item.title}</h2>}
						{item.items}
					</div>
				);
			})}
		</div>
	);
};

TooltipList.propTypes = {
	items: PropTypes.array,
};

export { TooltipList };
